import React from "react";
import { Helmet } from "react-helmet-async";

const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    name: "Lloyd Funding",
    description:
      "Lloyd Funding provides fast business funding solutions including term loans, lines of credit, merchant cash advances, and debt consolidation for small businesses.",
    url: "https://lloydfunding.com",
    logo: "https://lloydfunding.com/favicon-96x96.png",
    image: "https://lloydfunding.com/og-image.jpg",
    telephone: "+1-XXX-XXX-XXXX", // Add your phone number
    email: "info@lloydfunding.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Miami", // Update with actual city
      addressRegion: "FL", // Update with actual state
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "25.7617", // Update with actual coordinates
      longitude: "-80.1918",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
    sameAs: [
      "https://www.facebook.com/profile.php?id=61587466739704",
      "https://www.instagram.com/lloydfunding/",
      "https://x.com/lloydfunding",
      "https://www.linkedin.com/company/lloyd-funding/",
    ],
    priceRange: "$$",
    areaServed: {
      "@type": "Country",
      name: "United States",
    },
    serviceType: [
      "Business Term Loans",
      "Business Line of Credit",
      "Merchant Cash Advance",
      "Debt Consolidation",
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
